import { render, staticRenderFns } from "./v-announce-step.vue?vue&type=template&id=165feafe&scoped=true&"
import script from "./v-announce-step.vue?vue&type=script&lang=js&"
export * from "./v-announce-step.vue?vue&type=script&lang=js&"
import style0 from "./v-announce-step.vue?vue&type=style&index=0&id=165feafe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165feafe",
  null
  
)

export default component.exports